import { Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import Coins from '../utils/Coins';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';

let scale = isDesktop ? 1 : 2;

class WinHighlightController {
	winLevelIndex = 0;
	closing = false;
	timeout = null;
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.win = this.config.win;
		// this.win = 10;
		this.vc = this.vc['win_highlight_holder_up'][this.config.holder];
		this.win_counter = this.vc.win_highlight.win_counter;
		this.win_title = this.vc.win_highlight.win_title;
		this.car = this.vc.win_highlight.car;
		this.win_counter.scale.set(0);

		if (this.vc.getChildByName(this.config.item)) {
			if (HELPERS.getWinLevels().length > 0) {
				this.winLevels = HELPERS.getWinLevels();
				this.win_title = Sprite.from(
					Texture.from('title_' + this.winLevels[0].name)
				);
				this.win_title.position.set(0, -90);
				this.win_title.scale.set(0);
				this.win_title.anchor.set(0.5);
			}

			this.item = this.vc.getChildByName(this.config.item);
			this.width = this.vc.getBounds();
			this.item.handler = null;
			this.coins = new Coins();
			this.coins.position.set(-40, -120);

			this.vc.addChildAt(this.coins, 0);
			this.vc.win_highlight.addChild(this.win_title);
			this.vc.win_highlight.addChild(this.win_counter);

			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(
				() => {
					this.addEventListeners();
				},
				GameConfigs.settings.game_animation ? 750 : 300
			);
			this.coins.zIndex = 0;
			this.animOrShow();
			// this.initWings();
		} else {
			throw new Error(
				'WinHighlightController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	initWings() {
		// this.vc.win_highlight.wing_right.scale.set(0.8);
		// this.vc.win_highlight.wing_left.scale.set(0.8);
		this.vc.win_highlight.core.scale.set(0);
		this.vc.win_highlight.car.scale.set(0);
		this.vc.win_highlight.car.anchor.set(1);

		this.tweenCore = new Tween(this.vc.win_highlight.core.scale)
			.to({ x: isDesktop ? 1 : 2, y: isDesktop ? 1 : 2 }, 500)
			.easing(Easing.Back.Out)
			.start()
			.onComplete(() => {
				this.tweencar = new Tween(this.vc.win_highlight.car.scale)
					.to({ x: scale, y: scale }, 300)
					.easing(Easing.Linear.None)
					.start()
					.onComplete(() => {
						this.bounceCar = new Tween(this.vc.win_highlight.car)
							.to({ rotation: 0.01 }, 500)
							.yoyo(true)
							.repeat(Infinity)
							.easing(Easing.Quadratic.InOut)
							.start();
					});
			});
	}
	addEventListeners() {
		window.addEventListener(EVENTS.INTERACTION, this, false);
		window.addEventListener(EVENTS.BET_PLACED, this, false);
		window.addEventListener('keydown', this, false);
	}

	handleEvent(evt) {
		if (
			evt.type === EVENTS.INTERACTION ||
			(evt.type === EVENTS.BET_PLACED && evt.detail.placed) ||
			(evt.type === 'keydown' && GameConfigs.modal === 'win')
		) {
			this.removeListeners();
			if (GameConfigs.settings.game_animation) {
				this.process();
			} else {
				clearTimeout(this.timeout);
				this.removeWinHiglight();
			}
		}
	}

	animOrShow() {
		// HELPERS.disableAllButtons(true);
		if (GameConfigs.settings.game_animation) {
			this.anim();
		} else {
			this.show();
		}
		window.sm.play({ name: 'coin_sound', loop: true, volume: 0.5 });
	}

	getWinLevelIndex(win) {
		let percent = (win / GameConfigs.win) * 100;

		for (let index = this.winLevels.length - 1; index >= 0; index--) {
			if (percent > this.winLevels[index].min) {
				return index;
			}
		}
		return this.winLevelIndex;
	}

	process() {
		if (this.closing) {
			return;
		}
		if (this.tweener) {
			this.tweener.stop();
		}
		this.win = GameConfigs.win;
		this.winLevelIndex = this.winLevels.length - 1;
		let txt = (+this.win).toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});
		this.win_counter.anchor.x = 0.5;
		this.win_counter.position.set(txt.length * 5 - 20, -60);
		this.win_counter.text = txt;
		this.setTitle();
		window.sm.stop('coin_sound', 500);
		this.close();
	}

	setWin() {
		if (this.closing) {
			return;
		}
		let txt = (+this.win).toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});
		this.win_counter.text = txt;

		this.win_counter.anchor.x = 0.5;
		this.win_counter.position.set(txt.length * 5 - 20, -60);
		let wl = this.getWinLevelIndex(+this.win);
		if (wl !== this.winLevelIndex) {
			this.winLevelIndex = wl;
			this.setTitle();
		}
		// window.sm.play({ name: "coin_sound" });
		// window.sm.stop("coin_sound", 50);

		this.coins.addCoins(0.5);
	}

	setTitle() {
		if (this.closing) {
			return;
		}
		let last = this.win_title;

		if (this.tweenCore) {
			this.tweenCore.stop();
		}
		if (this.tweencar) {
			this.tweencar.stop();
		}
		if (this.bounceCar) {
			this.bounceCar.stop();
		}
		this.tweenCore = new Tween(this.vc.win_highlight.core.scale)
			.to({ x: 1.5, y: 1.5 }, 200)
			.yoyo(true)
			.repeat(1)
			.easing(Easing.Linear.None)
			.start();

		new Tween(last)
			.to({ alpha: 0 }, 200)
			.easing(Easing.Elastic.Out)
			.start()
			.onComplete(() => {
				this.vc.win_highlight.removeChild(last);
			});
		this.win_title = Sprite.from(
			Texture.from('title_' + this.winLevels[this.winLevelIndex].name)
		);
		this.win_title.position.set(0, -90);
		this.win_title.scale.set(2, 2);
		this.win_title.anchor.set(0.5);
		this.win_title.alpha = 0;
		this.vc.win_highlight.addChild(this.win_title);

		new Tween(this.win_title)
			.to({ alpha: 1 }, 700)
			.easing(Easing.Elastic.Out)
			.start();
		new Tween(this.win_title.scale)
			.to({ x: 1, y: 1 }, 700)
			.easing(Easing.Elastic.Out)
			.start();
	}

	updateBalance(a) {
		if (this.closing) {
			return;
		}
		if (GameConfigs.settings.game_animation) {
			this.tweener = new Tween(this)
				.to({ win: a }, this.winLevels[this.winLevels.length - 1].time)
				.easing(Easing.Linear.None)
				.onUpdate(() => {
					this.setWin();
				})
				.onComplete(() => {
					window.sm.stop('coin_sound', 500);
					this.close();
				})
				.start();
		}
	}

	close() {
		if (this.closing) {
			return;
		}
		this.closing = true;
		if (GameConfigs.settings.game_animation) {
			setTimeout(() => {
				new Tween(this.win_title.scale)
					.to({ x: 0, y: 0 }, 500)
					.easing(Easing.Back.In)
					.start();
				new Tween(this.win_counter.scale)
					.to({ x: 0, y: 0 }, 500)
					.easing(Easing.Back.In)
					.start();
				new Tween(this.vc.scale)
					.to({ x: 0, y: 0 }, 600)
					.delay(200)
					.onComplete(() => {
						this.removeWinHiglight();
					})
					.easing(Easing.Back.In)
					.start();
			}, 1000);
		}
	}

	anim() {
		if (GameConfigs.settings.game_animation) {
			// new Tween(this.vc.scale).to({ x: 1, y: 1 }, 400).easing(Easing.Bounce.Out).start();
			this.initWings();
			// this.tweenCore = new Tween(this.vc.win_highlight.core.scale).to({ x: 1, y: 1 }, 2000).easing(Easing.Back.Out).delay(500).start();
			new Tween(this.win_title.scale)
				.to({ x: 1, y: 1 }, 500)
				.delay(300)
				.easing(Easing.Bounce.Out)
				.onComplete(() => {
					this.win_counter.scale.set(1);
				})
				.start();
		}
		this.updateBalance(GameConfigs.win);
	}

	show() {
		this.stopTweens();
		this.init();
		let wl = this.getWinLevelIndex(+this.win);
		if (wl !== this.winLevelIndex) {
			this.winLevelIndex = wl;
		}
		this.win_title = Sprite.from(
			Texture.from('title_' + this.winLevels[this.winLevelIndex].name)
		);
		this.win_title.position.set(0, -90);
		this.win_title.anchor.set(0.5);
		this.vc.win_highlight.addChild(this.win_title);
		// this.vc.win_highlight.wing_left.position.set(-340, -80)
		// this.vc.win_highlight.wing_right.position.set(350, -80)
		this.timeout = setTimeout(() => {
			this.closing = true;
			this.removeWinHiglight();
		}, 1000);
	}
	init() {
		this.vc.scale.set(1);
		this.win_counter.scale.set(1);
		this.win_title.scale.set(1);
		this.car.scale.set(isDesktop ? 1 : 1.5);
		let x = isDesktop ? -290 : -240;
		let y = isDesktop ? -50 : 0;
		this.car.position.set(x, y);
		this.win = GameConfigs.win;
		this.winLevelIndex = this.winLevels.length - 1;
		let txt = (+this.win).toFixed(GameConfigs.config.currency_prec);
		let last = this.win_title;
		last.alpha = 0;
		this.win_counter.anchor.x = 0.5;
		this.win_counter.text = txt;
		this.win_counter.position.set(txt.length * 5 - 20, -60);
		// this.vc.win_highlight.wing_right.scale.set(1 * scale);
		// this.vc.win_highlight.wing_left.scale.set(1 * scale);
		// this.vc.win_highlight.wing_right.anchor.set(0, 0);
		// this.vc.win_highlight.wing_left.anchor.set(0, 0);
	}

	stopTweens() {
		if (this.vc.scale.tween) {
			this.vc.scale.tween.stop();
		}
		if (this.win_title.tween) {
			this.win_title.tween.stop();
		}
		if (this.win_title.tween) {
			this.win_title.tween.stop();
		}
		if (this.tweencar) {
			this.tweencar.stop();
		}
		if (this.bounceCar) {
			this.bounceCar.stop();
		}
	}
	removeWinHiglight() {
		if (this.vc.parent === null) {
			return;
		}
		this.dispatchClosingEvents();
		this.removeListeners();
	}

	dispatchClosingEvents() {
		window.sm.stop('coin_sound', 500);
		if (GameConfigs.modal === 'win') {
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		}
		HELPERS.disableAllButtons(false);
		// HELPERS.dispatchCustomEvent(EVENTS.PAUSE, { pause: false });
		HELPERS.dispatchCustomEvent(EVENTS.WIN_HIGHLIGHT, { open: false });
		HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: false });
	}

	removeListeners() {
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.BET_PLACED, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default WinHighlightController;
